/**
 * Resizable inquiry-list column geometry (desktop web).
 *
 * The list column in the three-pane inbox is draggable. The width lives as
 * React state in DesktopInbox; a divider drags it via DOM pointer events. The
 * clamp is kept here as a pure function so the boundary behavior is unit-tested
 * independently of the pointer-event plumbing, which is hard to exercise in a
 * component test.
 *
 * Bounds are deliberate: below MIN the four status-tab labels
 * (All / Open / Closed / Drafts) cramp and the inquiry cards truncate to
 * unusable, and above MAX the chat pane loses too much room on common laptop
 * widths. MIN is set to keep the tabs labeled rather than collapsing to icons.
 */
export const LIST_MIN_WIDTH = 400;

export const LIST_MAX_WIDTH = 680;

export const LIST_DEFAULT_WIDTH = 512;

/**
 * Clamp a proposed column width to the allowed range.
 */
export function clampListWidth(width: number): number {
  return Math.max(LIST_MIN_WIDTH, Math.min(LIST_MAX_WIDTH, width));
}

/**
 * Width after dragging the divider `deltaX` pixels from `baseWidth`. Positive
 * `deltaX` (drag right) widens the list; the result is clamped to the range.
 */
export function nextListWidth(baseWidth: number, deltaX: number): number {
  return clampListWidth(baseWidth + deltaX);
}
